import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList as _getList, addObj, updateObj, delObj, getCategory as _getCategory, copyObj } from '@/api/bigscreen/visual';
export default {
  name: "list",
  data: function data() {
    return {
      loading: false,
      typelist: [],
      index: 0,
      type: '',
      option: {
        column: [{
          label: '分组',
          prop: 'category',
          span: 24,
          labelWidth: 100,
          type: 'select',
          dicUrl: this.url + '/category/list',
          props: {
            label: 'categoryKey',
            value: 'categoryValue'
          },
          rules: [{
            required: true,
            message: "请选择分组",
            trigger: "blur"
          }]
        }, {
          label: '大屏名称',
          span: 24,
          labelWidth: 100,
          prop: 'title',
          rules: [{
            required: true,
            message: "请输入大屏名称",
            trigger: "blur"
          }]
        }, {
          label: '大屏尺寸',
          span: 14,
          labelWidth: 100,
          prop: 'width',
          placeholder: '请输入宽度',
          rules: [{
            required: true,
            message: "请输入大屏尺寸",
            trigger: "blur"
          }]
        }, {
          label: '',
          span: 10,
          labelWidth: 1,
          prop: 'height',
          placeholder: '请输入高度',
          rules: [{
            required: true,
            message: "请输入大屏尺寸",
            trigger: "blur"
          }]
        }, {
          label: '密码',
          span: 24,
          type: 'password',
          labelWidth: 100,
          prop: 'password'
        }, {
          label: '发布状态',
          prop: 'status',
          span: 24,
          labelWidth: 100,
          type: 'select',
          dicData: [{
            label: '未发布',
            value: 0
          }, {
            label: '已发布',
            value: 1
          }]
        }]
      },
      page: {
        page: 1,
        size: 10,
        total: 0
      },
      form: {},
      box: false,
      activeName: '',
      list: []
    };
  },
  created: function created() {
    this.getCategory();
  },
  methods: {
    vaildData: function vaildData(id) {
      var list = [];

      for (var i = 0; i < 20; i++) {
        list.push(i);
      }

      return list.includes(id);
    },
    getCategory: function getCategory() {
      var _this = this;

      _getCategory().then(function (res) {
        var data = res.data.data;
        _this.typelist = data;
        _this.activeName = (data[0] || {}).categoryValue;

        _this.getList();
      });
    },
    handleCopy: function handleCopy(item) {
      var _this2 = this;

      this.$confirm('确认复制当前大屏', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        copyObj(item.id).then(function () {
          _this2.$message.success('复制成功');

          _this2.getList();
        });
      }).catch(function () {});
    },
    handleDel: function handleDel(item, index) {
      var _this3 = this;

      this.$confirm('是否确认永久删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (_this3.vaildData(index)) {
          _this3.$message.error('例子模板不允许修改');

          return false;
        }

        delObj(item.id).then(function () {
          _this3.list.splice(index, 1);

          _this3.$message.success('删除成功');
        });
      }).catch(function () {});
    },
    handleAdd: function handleAdd() {
      this.type = 'add';
      this.findObject(this.option.column, 'status').display = false;
      this.findObject(this.option.column, 'width').display = true;
      this.findObject(this.option.column, 'height').display = true;
      this.form.title = '';
      this.form.status = '';
      this.form.password = '';
      this.form.category = this.activeName;
      this.form.width = 1920;
      this.form.height = 1080;
      this.box = true;
    },
    handleUpdate: function handleUpdate(item, index) {
      this.type = 'edit';
      this.findObject(this.option.column, 'status').display = true;
      this.findObject(this.option.column, 'width').display = false;
      this.findObject(this.option.column, 'height').display = false;
      this.form = item;
      this.form.category = this.form.category + '';
      this.box = true;
      this.index = index;
    },
    handleEdit: function handleEdit(item) {
      var routeUrl = this.$router.resolve({
        path: '/build/' + item.id
      });
      window.open(routeUrl.href, '_blank');
    },
    handleViews: function handleViews(item) {
      var routeUrl = this.$router.resolve({
        path: '/view/' + item.id
      });
      window.open(routeUrl.href, '_blank');
    },
    handleSave: function handleSave(form, done) {
      var _this4 = this;

      done();

      if (this.type == 'add') {
        addObj(Object.assign({
          category: this.activeName
        }, this.form)).then(function (res) {
          _this4.box = false;

          _this4.$message.success('新增成功');

          _this4.getList();

          var id = res.data.data.id;

          _this4.handleEdit({
            id: id
          });
        });
      } else {
        if (this.vaildData(Number(this.index))) {
          this.$message.error('例子模板不允许修改');
          return false;
        }

        updateObj({
          id: this.form.id,
          category: this.form.category,
          password: this.form.password,
          status: this.form.status,
          title: this.form.title
        }).then(function () {
          _this4.box = false;

          _this4.$message.success('修改成功');

          _this4.getList();
        });
      }
    },
    handleSelect: function handleSelect(key) {
      this.activeName = key;
      this.page.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.page = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    getList: function getList(category) {
      var _this5 = this;

      this.loading = true;
      this.list = [];

      _getList({
        category: category || this.activeName,
        current: this.page.page,
        size: this.page.size
      }).then(function (res) {
        _this5.loading = false;
        var data = res.data.data;
        _this5.page.total = data.total;
        _this5.list = data.records;

        _this5.initData();
      });
    },
    initData: function initData() {
      var _this6 = this;

      this.list.forEach(function (ele, index) {
        _this6.$set(_this6.list[index], '_menu', false);
      });
    }
  }
};